(function () {
  if (window.__gwpDrawerInit) return;
  window.__gwpDrawerInit = true;

  var BANNER_CSS = [
    '.gwp-drawer-banner {',
    '  margin: 20px 24px;',
    '  padding: 18px 18px 20px;',
    '  border: 1.5px solid #ECF4EF;',
    '  border-radius: 18px;',
    '  background: #ECF4EF;',
    '  font-family: studiofeixen, sans-serif;',
    '  box-sizing: border-box;',
    '}',
    '.gwp-drawer-banner__label-row {',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 9px;',
    '}',
    '.gwp-drawer-banner__label {',
    '  font-size: 11px;',
    '  font-weight: 500;',
    '  letter-spacing: 0.12em;',
    '  text-transform: uppercase;',
    '  color: #34B78F;',
    '}',
    '.gwp-drawer-banner__heading {',
    '  margin: 10px 0 0;',
    '  font-size: 13px;',
    '  font-weight: 400;',
    '  line-height: 18px;',
    '  color: #244545;',
    '}',
    '.gwp-drawer-banner__products {',
    '  display: grid;',
    '  grid-template-columns: 1fr 1fr;',
    '  gap: 12px;',
    '  margin-top: 14px;',
    '}',
    '.gwp-drawer-banner__product {',
    '  display: flex;',
    '  flex-direction: column;',
    '  gap: 8px;',
    '  padding: 10px;',
    '  border-radius: 14px;',
    '  background: #fff;',
    '  border: 1.5px solid #E7E8E8;',
    '  box-sizing: border-box;',
    '}',
    '.gwp-drawer-banner__media {',
    '  position: relative;',
    '  border-radius: 10px;',
    '  overflow: hidden;',
    '  aspect-ratio: 4 / 3;',
    '}',
    '.gwp-drawer-banner__image {',
    '  display: block;',
    '  width: 100%;',
    '  height: 100%;',
    '  object-fit: cover;',
    '  background: #f3f3f3;',
    '}',
    '.gwp-drawer-banner__badge {',
    '  position: absolute;',
    '  top: 6px;',
    '  left: 6px;',
    '  background: #ECF166;',
    '  color: #244545;',
    '  font-size: 9px;',
    '  font-weight: 700;',
    '  letter-spacing: 0.06em;',
    '  text-transform: uppercase;',
    '  padding: 4px 8px;',
    '  border-radius: 54px;',
    '}',
    '.gwp-drawer-banner__title {',
    '  margin: 0;',
    '  font-size: 12px;',
    '  font-weight: 400;',
    '  line-height: 15px;',
    '  color: #244545;',
    '}',
    '.gwp-drawer-banner__subtitle {',
    '  margin: 0;',
    '  font-size: 11px;',
    '  line-height: 14px;',
    '  color: #6D7878;',
    '}',
    '.gwp-drawer-banner__price {',
    '  display: flex;',
    '  align-items: baseline;',
    '  gap: 6px;',
    '}',
    '.gwp-drawer-banner__price s {',
    '  font-size: 11px;',
    '  color: #9DA5A5;',
    '}',
    '.gwp-drawer-banner__free {',
    '  font-size: 11px;',
    '  font-weight: 500;',
    '  color: #34B78F;',
    '}',
    '.gwp-drawer-banner__btn {',
    '  margin-top: 2px;',
    '  height: 36px;',
    '  border: 1.5px solid #244545;',
    '  border-radius: 54px;',
    '  background: transparent;',
    '  color: #244545;',
    '  font-family: studiofeixen, sans-serif;',
    '  font-size: 11px;',
    '  text-transform: uppercase;',
    '  letter-spacing: 0.5px;',
    '  cursor: pointer;',
    '}',
    '.gwp-drawer-banner__btn[disabled] {',
    '  border-color: #E7E8E8;',
    '  color: #6D7878;',
    '  cursor: default;',
    '}'
  ].join('\n');

  var GIFT_ITEM_CSS = [
    '#cart-drawer [role="listitem"][data-gwp-gift] {',
    '  background-color: #ECF4EF !important;',
    '  border: 1.5px solid #ECF4EF !important;',
    '  border-radius: 14px !important;',
    '}',
    '#cart-drawer [role="listitem"][data-gwp-gift] img {',
    '  border-radius: 10px !important;',
    '}',
    '#cart-drawer [role="listitem"][data-gwp-gift] [part="money"] {',
    '  color: #9DA5A5 !important;',
    '}',
    '#cart-drawer [role="listitem"][data-gwp-gift] [part~="discount"] {',
    '  color: #34B78F !important;',
    '  font-weight: 500 !important;',
    '}',
    '.gwp-gift-badge {',
    '  display: inline-block;',
    '  align-self: flex-start;',
    '  margin: 0 0 6px;',
    '  padding: 4px 9px;',
    '  border-radius: 54px;',
    '  background: #ECF166;',
    '  color: #244545;',
    '  font-family: studiofeixen, sans-serif;',
    '  font-size: 10px;',
    '  font-weight: 700;',
    '  letter-spacing: 0.1em;',
    '  text-transform: uppercase;',
    '}',
    '.gwp-gift-actions {',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 14px;',
    '  margin-top: 6px;',
    '}',
    '.gwp-gift-actions a {',
    '  font-family: studiofeixen, sans-serif;',
    '  font-size: 12px;',
    '  font-weight: 400;',
    '  line-height: 1;',
    '  color: #244545;',
    '  text-decoration: underline;',
    '  text-underline-offset: 2px;',
    '  cursor: pointer;',
    '}',
    '.gwp-gift-actions a.gwp-gift-actions__remove {',
    '  color: #6D7878;',
    '}'
  ].join('\n');

  var CARD_MEDIA_BG = ['#FDFEF0', '#D5E9E1'];

  var GIFT_ICON_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#34B78F" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8"></path>' +
    '<path d="M2 7h20v5H2z"></path>' +
    '<path d="M12 21V7"></path>' +
    '<path d="M12 7S9.5 3 7.5 3.5 6 7 6 7s3-.2 6 0zM12 7s2.5-4 4.5-3.5S18 7 18 7s-3-.2-6 0z"></path>' +
    '</svg>';

  function injectBannerStyles(shadowRoot) {
    if (shadowRoot.querySelector('#gwp-banner-styles')) return;
    var style = document.createElement('style');
    style.id = 'gwp-banner-styles';
    style.textContent = BANNER_CSS;
    shadowRoot.appendChild(style);
  }

  function injectGiftItemStyles(shadowRoot) {
    if (shadowRoot.querySelector('#gwp-gift-item-styles')) return;
    var style = document.createElement('style');
    style.id = 'gwp-gift-item-styles';
    style.textContent = GIFT_ITEM_CSS;
    shadowRoot.appendChild(style);
  }

  function decorateGiftRow(row) {
    row.setAttribute('data-gwp-gift', '1');

    var qtyWrapper = row.querySelector('div:has(> input[name="quantity"])');
    if (qtyWrapper) qtyWrapper.style.setProperty('display', 'none', 'important');

    var fsWrapper = row.querySelector('div:has(select[name="selling_plan"])');
    if (fsWrapper) fsWrapper.style.setProperty('display', 'none', 'important');

    var subBtn = row.querySelector('button[class*="bg-storefront-drawer-secondary"]');
    if (subBtn) subBtn.style.setProperty('display', 'none', 'important');

    var titlePara = row.querySelector('p.font-semibold');
    if (!titlePara) return;
    var nameCol = titlePara.parentElement;

    if (!nameCol.querySelector('.gwp-gift-badge')) {
      var badge = document.createElement('span');
      badge.className = 'gwp-gift-badge';
      badge.textContent = 'TWÓJ PREZENT';
      nameCol.insertBefore(badge, titlePara);
    }

    if (!nameCol.querySelector('.gwp-gift-actions')) {
      var trashBtn = row.querySelector('button[data-rc-trash], button:has(svg.lucide-trash2)');
      if (trashBtn) trashBtn.style.setProperty('display', 'none', 'important');

      var actions = document.createElement('div');
      actions.className = 'gwp-gift-actions';

      var changeLink = document.createElement('a');
      changeLink.href = '#';
      changeLink.textContent = 'zmień prezent';
      changeLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (trashBtn) trashBtn.click();
      });
      actions.appendChild(changeLink);

      var removeLink = document.createElement('a');
      removeLink.href = '#';
      removeLink.className = 'gwp-gift-actions__remove';
      removeLink.textContent = 'usuń';
      removeLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (trashBtn) trashBtn.click();
      });
      actions.appendChild(removeLink);

      nameCol.appendChild(actions);
    }
  }

  function undecorateGiftRow(row) {
    row.removeAttribute('data-gwp-gift');

    var qtyWrapper = row.querySelector('div:has(> input[name="quantity"])');
    if (qtyWrapper) qtyWrapper.style.removeProperty('display');

    var fsWrapper = row.querySelector('div:has(select[name="selling_plan"])');
    if (fsWrapper) fsWrapper.style.removeProperty('display');

    var subBtn = row.querySelector('button[class*="bg-storefront-drawer-secondary"]');
    if (subBtn) subBtn.style.removeProperty('display');

    var trashBtn = row.querySelector('button[data-rc-trash], button:has(svg.lucide-trash2)');
    if (trashBtn) trashBtn.style.removeProperty('display');

    var badge = row.querySelector('.gwp-gift-badge');
    if (badge) badge.remove();

    var actions = row.querySelector('.gwp-gift-actions');
    if (actions) actions.remove();
  }

  // A row only gets the green "claimed gift" treatment if BOTH:
  //  1. its title matches one of the two configured gift products, and
  //  2. that specific line's current price renders as exactly zero.
  // (2) is what separates an actually-claimed free gift (added via the popup
  // or the drawer widget, carrying the "_gwp" line item property the
  // gwp-price Cart Transform Function checks server-side before zeroing the
  // price) from the exact same product bought normally from its own product
  // page - same title, but never marked "_gwp" so the transform never
  // touches its price. Title alone can't tell those two apart, and two
  // separate line items with the very same title can legitimately coexist
  // (Shopify never merges lines that differ in line item properties) - one
  // claimed for free, one bought normally - so this must be decided per row,
  // not per product.
  //
  // Rows are matched by their own rendered title text, never by position in
  // #cart-drawer's row list vs. /cart.js's items array. ReCharge doesn't expose
  // product/variant IDs anywhere in the drawer DOM (same limitation noted for
  // the native trash button), and the row order there isn't guaranteed to
  // track /cart.js's item order 1:1 at every moment - a fetched cart can lag
  // one render behind a fast add, and cross-sell adds have been observed to
  // shift row order relative to the array. Index correlation caused the
  // trigger product's row to intermittently get decorated as a gift instead
  // of the actual gift row. Matching on the title actually painted on screen
  // sidesteps that race entirely.
  // Checking for *any* discount indicator isn't enough - a subscription
  // discount on the same gift-eligible product bought normally renders with
  // the exact same [part~="discount"] treatment (struck-through original +
  // a lower current price), so that alone can't tell a subscription discount
  // apart from our cart transform. What's unique to a claimed gift is that
  // the gwp-price Cart Transform Function forces the line's price to exactly
  // zero - a subscription discount essentially never does that. So this
  // reads the actual CURRENT price (the discount part when present, since
  // that's what shows the post-adjustment price; otherwise the plain money
  // part) and requires it to parse to 0.
  function rowFinalPriceIsZero(row) {
    var priceEl = row.querySelector('[part~="discount"]') ||
      row.querySelector('[part="money"]:not(.line-through)');
    if (!priceEl) return false;
    var numeric = parseFloat((priceEl.textContent || '').replace(/[^\d,.-]/g, '').replace(',', '.'));
    return !isNaN(numeric) && numeric === 0;
  }

  function styleGiftLineItems(shadowRoot, config) {
    var giftTitles = config.gifts.map(function (g) {
      return (g.title || '').trim().toLowerCase();
    }).filter(Boolean);
    if (!giftTitles.length) return;

    var rows = shadowRoot.querySelectorAll('#cart-drawer [role="listitem"]');
    var injected = false;

    rows.forEach(function (row) {
      var titlePara = row.querySelector('p.font-semibold');
      var title = titlePara ? titlePara.textContent.trim().toLowerCase() : '';
      var isGift = !!title && giftTitles.indexOf(title) !== -1 && rowFinalPriceIsZero(row);

      if (isGift) {
        if (!injected) {
          injectGiftItemStyles(shadowRoot);
          injected = true;
        }
        decorateGiftRow(row);
      } else if (row.getAttribute('data-gwp-gift') === '1') {
        undecorateGiftRow(row);
      }
    });
  }

  function buildBanner(config) {
    var wrap = document.createElement('div');
    wrap.className = 'gwp-drawer-banner';

    var labelRow = document.createElement('div');
    labelRow.className = 'gwp-drawer-banner__label-row';
    labelRow.innerHTML = GIFT_ICON_SVG;
    var label = document.createElement('span');
    label.className = 'gwp-drawer-banner__label';
    label.textContent = config.drawerEyebrow || 'Wybierz prezent do zamówienia';
    labelRow.appendChild(label);
    wrap.appendChild(labelRow);

    var heading = document.createElement('p');
    heading.className = 'gwp-drawer-banner__heading';
    heading.textContent = config.bannerHeading || '';
    wrap.appendChild(heading);

    var products = document.createElement('div');
    products.className = 'gwp-drawer-banner__products';

    config.gifts.forEach(function (gift, index) {
      var card = document.createElement('div');
      card.className = 'gwp-drawer-banner__product';

      var media = document.createElement('div');
      media.className = 'gwp-drawer-banner__media';
      media.style.background = CARD_MEDIA_BG[index % CARD_MEDIA_BG.length];

      var badge = document.createElement('span');
      badge.className = 'gwp-drawer-banner__badge';
      badge.textContent = 'Prezent';
      media.appendChild(badge);

      if (gift.image) {
        var img = document.createElement('img');
        img.className = 'gwp-drawer-banner__image';
        img.src = gift.image;
        img.alt = gift.title || '';
        img.width = 400;
        img.height = 300;
        img.loading = 'lazy';
        media.appendChild(img);
      }
      card.appendChild(media);

      var title = document.createElement('p');
      title.className = 'gwp-drawer-banner__title';
      title.textContent = gift.title || '';
      card.appendChild(title);

      if (gift.caption) {
        var subtitle = document.createElement('p');
        subtitle.className = 'gwp-drawer-banner__subtitle';
        subtitle.textContent = gift.caption;
        card.appendChild(subtitle);
      }

      if (gift.price) {
        var priceRow = document.createElement('div');
        priceRow.className = 'gwp-drawer-banner__price';
        var s = document.createElement('s');
        s.textContent = gift.price;
        priceRow.appendChild(s);
        var free = document.createElement('span');
        free.className = 'gwp-drawer-banner__free';
        free.textContent = config.freePriceLabel || 'Twój prezent: 0 zł';
        priceRow.appendChild(free);
        card.appendChild(priceRow);
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gwp-drawer-banner__btn';
      btn.setAttribute('data-gwp-index', String(index));

      if (gift.available === false) {
        btn.textContent = 'Niedostępne';
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.textContent = config.ctaLabel || 'Dodaj za darmo';
      }

      btn.addEventListener('click', function () {
        if (gift.available === false) return;
        if (!window.GiftWithPurchase) return;
        products.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('disabled', 'disabled');
        });
        window.GiftWithPurchase.addGift(gift.variantId).catch(function (e) {
          console.error(e);
          products.querySelectorAll('button').forEach(function (b) {
            var i = parseInt(b.getAttribute('data-gwp-index'), 10);
            if (config.gifts[i] && config.gifts[i].available === false) return;
            b.removeAttribute('disabled');
          });
        });
      });
      card.appendChild(btn);

      products.appendChild(card);
    });

    wrap.appendChild(products);
    return wrap;
  }

  var pendingCheck = null;
  var removalInFlight = false;

  function removeOrphanedGifts(shadowRoot, cart) {
    if (removalInFlight) return;
    if (!window.GiftWithPurchase) return;

    // Only lines actually claimed via the "_gwp" property get auto-removed
    // here - a normal purchase of the same product must never be touched,
    // even while the trigger is missing from the cart.
    var rows = shadowRoot.querySelectorAll('#cart-drawer [role="listitem"]');
    var giftLineItems = [];
    cart.items.forEach(function (item, idx) {
      if (window.GiftWithPurchase.itemIsClaimedGift(item)) {
        giftLineItems.push({ item: item, row: rows[idx] });
      }
    });
    if (!giftLineItems.length) return;

    removalInFlight = true;

    var removedQuantity = 0;
    var chain = Promise.resolve();
    giftLineItems.forEach(function (entry) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: entry.item.key, quantity: 0 })
        }).then(function (r) {
          return r.json();
        });
      });
    });

    chain
      .then(function (updatedCart) {
        giftLineItems.forEach(function (entry) {
          removedQuantity += entry.item.quantity;
          if (entry.row) entry.row.style.setProperty('display', 'none', 'important');
        });

        var badge = shadowRoot.querySelector('.rc-cart-count-badge');
        if (badge) {
          var n = parseInt(badge.textContent, 10);
          if (!isNaN(n)) badge.textContent = Math.max(0, n - removedQuantity);
        }

        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: updatedCart }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        removalInFlight = false;
      });
  }

  function refreshBanner(shadowRoot) {
    if (pendingCheck) clearTimeout(pendingCheck);
    pendingCheck = setTimeout(function () {
      var config = window.giftWithPurchaseConfig;
      if (!config || !config.enabled) return;

      // Runs directly against the rows currently on screen - no /cart.js
      // round trip, so it can't race a fetched cart against a DOM that has
      // since moved on (see styleGiftLineItems' own comment for why position
      // matching was dropped instead of just fixed here).
      styleGiftLineItems(shadowRoot, config);

      if (!config.triggerProductId) return;
      if (!window.GiftWithPurchase) return;

      window.GiftWithPurchase.getCart().then(function (cart) {
        var triggerPresent = window.GiftWithPurchase.cartHasProduct(cart, config.triggerProductId);
        var giftPresent = window.GiftWithPurchase.cartHasClaimedGift(cart);

        if (!triggerPresent) {
          sessionStorage.removeItem('gwp_popup_seen');

          if (giftPresent) {
            removeOrphanedGifts(shadowRoot, cart);
          }
        }

        var existing = shadowRoot.querySelector('.gwp-drawer-banner');

        if (triggerPresent && !giftPresent) {
          // Insert above the "recommended products" upsell carousel rather than
          // at the very bottom of the drawer. Must match the immediate local
          // wrapper (direct child div > direct child carousel) - the same
          // selector already used elsewhere in layout/theme.liquid for this
          // exact block - not the broader "any div containing the carousel
          // anywhere" selector, which matches the whole scrollable drawer
          // body (an ancestor of the line items too).
          //
          // The recommendation carousel loads asynchronously, so on first
          // render it may not exist yet - we fall back to inserting before
          // the footer in that case. Re-check and re-anchor on every refresh
          // (not just on first insert) so that once the carousel does show
          // up, the banner moves above it instead of staying stuck at the
          // bottom forever.
          var upsellBlock = shadowRoot.querySelector('#cart-drawer div:has(> div > [data-slot="carousel"])');
          var anchor = upsellBlock || shadowRoot.querySelector('#cart-drawer footer');
          if (!anchor || !anchor.parentNode) return;

          if (!existing) {
            injectBannerStyles(shadowRoot);
            anchor.parentNode.insertBefore(buildBanner(config), anchor);
          } else if (existing.nextElementSibling !== anchor) {
            anchor.parentNode.insertBefore(existing, anchor);
          }
        } else if (existing) {
          existing.remove();
        }
      });
    }, 150);
  }

  function findUpsellDismissButton(shadowRoot) {
    var dialogs = shadowRoot.querySelectorAll('[role="dialog"]');
    for (var i = 0; i < dialogs.length; i++) {
      var dialog = dialogs[i];
      if (dialog.querySelector('#cart-drawer')) continue;

      var buttons = dialog.querySelectorAll('button');
      for (var j = 0; j < buttons.length; j++) {
        var text = (buttons[j].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (text.indexOf('jednorazowo') !== -1) return buttons[j];
      }

      var fieldset = dialog.querySelector('fieldset');
      if (fieldset) {
        var fieldsetButtons = fieldset.querySelectorAll('button');
        if (fieldsetButtons.length >= 2) return fieldsetButtons[1];
      }
    }
    return null;
  }

  function dismissUpsellIfNeeded(shadowRoot) {
    if (!window.__gwpSuppressUpsell) return;
    var btn = findUpsellDismissButton(shadowRoot);
    if (!btn) return;
    window.__gwpSuppressUpsell = false;
    btn.click();
  }

  function initShadowRoot(shadowRoot) {
    if (shadowRoot._gwpInit) return;
    shadowRoot._gwpInit = true;

    dismissUpsellIfNeeded(shadowRoot);
    refreshBanner(shadowRoot);

    // characterData is required in addition to childList: React (which
    // ReCharge's drawer is built with) commonly updates a line's price by
    // setting an existing text node's data in place rather than replacing
    // the element - e.g. right after addGift() resolves and the cart
    // transform's zeroed price arrives a beat later than the row itself.
    // A childList-only observer never fires for that, so
    // rowFinalPriceIsZero() could keep reading the stale pre-transform
    // price indefinitely with nothing left to trigger a re-check.
    new MutationObserver(function () {
      dismissUpsellIfNeeded(shadowRoot);
      refreshBanner(shadowRoot);
    }).observe(shadowRoot, { childList: true, subtree: true, characterData: true });
  }

  function findCartDrawerShadowRoot() {
    var elements = document.body.querySelectorAll('*');
    for (var i = 0; i < elements.length; i++) {
      var sr = elements[i].shadowRoot;
      if (sr && sr.querySelector('#cart-drawer')) {
        initShadowRoot(sr);
        return;
      }
    }
  }

  function initOverlayShadowRoot(overlaySR) {
    if (overlaySR._gwpOverlayInit) return;
    overlaySR._gwpOverlayInit = true;

    dismissUpsellIfNeeded(overlaySR);

    new MutationObserver(function () {
      dismissUpsellIfNeeded(overlaySR);
    }).observe(overlaySR, { childList: true, subtree: true });
  }

  function findOverlayShadowRoot() {
    var overlayHost = document.querySelector('#recharge-storefront-experiences__cart-overlay');
    if (overlayHost && overlayHost.shadowRoot) {
      initOverlayShadowRoot(overlayHost.shadowRoot);
    }
  }

  new MutationObserver(function () {
    findCartDrawerShadowRoot();
    findOverlayShadowRoot();
  }).observe(document.body, { childList: true, subtree: true });

  findCartDrawerShadowRoot();
  findOverlayShadowRoot();
})();
